/* eslint-disable */
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Grid from '@material-ui/core/Grid';
import { DateTime } from 'luxon';
import useSWR from 'swr';
import { variantFetcher, fetcher } from '../../service/SWRFetcher';
import useApp from '../../hooks/useApp';
import Filter from '../../components/Filter';
import { Header, Container } from '../../styles/shared/styles';
import { AutocompleteField } from '../../components/FormFields';
import FrameReasons from './FrameReasons';
import FrameSummary from './FrameSummary';
import FrameMetrics from './FrameMetrics';
import FrameMetricsByChannel from './FrameMetricsByChannel';
import './styles.css';
import api from '../../service/api';

const ProductionRanking = () => {
    const { data: users } = useSWR('/users', fetcher);
    const { insurances, partners } = useApp();
    const [productionRanking, setProductionRanking] = useState(null);
    const [getListSubGroupChannels, setListSubGroupChannels] = useState([]);

    const [filters, setFilters] = useState({
        initDate: DateTime.now().toISODate(),
        endDate: DateTime.now().toISODate(),
        selectedChannel: null,
        selectedUser: null,
        partners: null,
    });

    const {
        data: listSubGroupChannels,
        mutate,
        isValidating,
    } = useSWR(
        `/channels-subgroup`,
        variantFetcher
    );

    useEffect(() => {
        if (listSubGroupChannels?.data) {
            setListSubGroupChannels([...listSubGroupChannels?.data]);
        }
    }, [listSubGroupChannels]);

    const partnersFilter = () => {
        if (!filters.partners || filters.partners.length === 0) return '';

        let stringPartnersFilter = '';
        filters.partners.map((p) => (stringPartnersFilter += `&partner_id[]=${p.id}`));
        return stringPartnersFilter;
    };

    const handleFilter = async () => {
        const result = await api.get(`/production-ranking/?`+
            `initDate=${filters.initDate}`+
            `&endDate=${filters.endDate}`+
            `&channelId=${filters.selectedChannel?.id || null}`+
            `&brokerId=${filters.selectedUser?.id || null}`+
            partnersFilter()
        );

        setProductionRanking(result.data.data);
    }

    const handleClear = () => {
        setFilters({
            initDate: DateTime.now().toISODate(),
            endDate: DateTime.now().toISODate(),
            lead: null,
            cleanLeadOption: null,
            client: null,
        });
    }; 

    const handleChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const handleAutoCompleteChange = (e, newValue, variable) => {
        setFilters({
            ...filters,
            [variable]: newValue,
          });
    }


    return (
        <>
        <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -100 }}>
            <Container>
                <Header>
                    <div style={{margin: 'auto'}}>
                        <h1>Painel do Consultor [{filters.selectedUser?.name ?? 'TODOS'}]</h1>
                        <br />
                        <h3>Ranking de Produção [{filters.selectedChannel?.name ?? 'TODOS Canais' }]</h3>
                    </div>
                </Header>

                <Filter
                    navbarStyle={{"display" : "block"}}
                    buttonStyle={{"height": "fit-content"}}
                    clickFilter={handleFilter}
                    clearFilter={handleClear}
                >
                <Grid container spacing={2}>

                    <label>
                        Data início:
                        <input
                        type="date"
                        name="initDate"
                        className="input-form"
                        title='De'
                        value={filters.initDate}
                        onChange={handleChange}
                        />
                    </label>

                    <label>
                        Data fim:
                        <input
                        type="date"
                        name="endDate"
                        className="input-form"
                        title='Até'
                        value={filters.endDate}
                        onChange={handleChange}
                        />
                    </label>

                    <AutocompleteField
                        className="control g"
                        valueText={filters.selectedChannel}
                        options={getListSubGroupChannels}
                        value={filters.selectedChannel || []}
                        varibleName="selectedChannel"
                        onChange={handleAutoCompleteChange}
                        label="Canal"
                        style={{width: '290px'}}
                    />
                     <AutocompleteField
                        className="control g"
                        valueText={filters.selectedUser}
                        options={users}
                        value={filters.selectedUser || null}
                        varibleName="selectedUser"
                        onChange={handleAutoCompleteChange}
                        label="Corretor"
                        style={{width: '220px'}}
                    />

                    <AutocompleteField
                        multiple
                        className="control g"
                        valueText={filters.partners}
                        options={partners}
                        value={filters.partners || []}
                        varibleName="partners"
                        onChange={handleAutoCompleteChange}
                        label="Empresas"
                        style={{width: '220px'}}
                    />

                </Grid>
                </Filter>

                <div className='frameBackground'>
                    <FrameReasons data={productionRanking?.reasons}/>
                    <FrameSummary data={productionRanking?.summary}/>
                    <FrameMetrics data={productionRanking?.metrics}/>
                    <FrameMetricsByChannel data={productionRanking?.userMetrics} 
                        selectedChannelName={filters.selectedChannel?.name}
                        selectedChannelId={filters.selectedChannel?.id}
                        metricsComissao={productionRanking?.metrics[2].qtd}
                        metricsConversao={productionRanking?.metrics[3].qtd}
                    />
                </div>
                
            </Container>
        </motion.div>
        </>
    )
}

export default ProductionRanking;